import { generatePath } from 'react-router-dom';

import { Navigate, useTypedParams } from '@sorare/routing';

import { MLB_PLAY_LINEUPS_EVENTTYPE_FIXTURE } from '@sorare/core/src/constants/__generated__/routes';

import type { PageParams } from './__generated__/routeParams';

const EventTypePage = () => {
  const { eventType } = useTypedParams<PageParams>();

  return (
    <Navigate
      to={generatePath(MLB_PLAY_LINEUPS_EVENTTYPE_FIXTURE, {
        eventType,
        fixture: 'ongoing',
      })}
    />
  );
};
export default EventTypePage;
